import { render } from "./McpSection.vue?vue&type=template&id=f1cf8ec2"
import script from "./McpSection.vue?vue&type=script&lang=js"
export * from "./McpSection.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__